import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { fetchWallet } from '../services/billingService';
import '../css/App.css';
import './ProfilePage.css';
import './BillingReturnPages.css';

/**
 * Shown after Stripe redirects back with ?session_id=…
 * Credits are applied server-side via webhook; we refresh wallet for display.
 */
export function BillingSuccessPage() {
  const [searchParams] = useSearchParams();
  const hasSession = Boolean(searchParams.get('session_id'));
  const [credits, setCredits] = useState(null);
  const [walletLoaded, setWalletLoaded] = useState(false);
  const [walletError, setWalletError] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const w = await fetchWallet();
        if (!cancelled) {
          setCredits(typeof w?.availableCredits === 'number' ? w.availableCredits : null);
          setWalletLoaded(true);
        }
      } catch {
        if (!cancelled) {
          setWalletError(true);
          setWalletLoaded(true);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [hasSession]);

  return (
    <div className="profile-container billing-return" role="main">
      <h2>Payment successful</h2>
      <p>
        Thank you — your payment was received. Purchased credits are added by our server; it may take a few
        seconds to appear in your balance after the payment completes.
      </p>
      {!hasSession && (
        <p className="billing-return__note">
          <small>No session id in URL (you can still confirm your balance below).</small>
        </p>
      )}
      {walletError && (
        <p className="billing-return__warning">
          You’re signed out or the wallet could not be loaded yet. Open Profile shortly to confirm your
          credits.
        </p>
      )}
      {!walletError && (
        <div className="form-group wallet-summary-group">
          <label>Publishing Credits</label>
          <div className="wallet-summary">
            <span className="wallet-summary__balance">
              {!walletLoaded
                ? 'Loading balance…'
                : typeof credits === 'number'
                  ? `${credits} credit${credits !== 1 ? 's' : ''} available`
                  : 'Balance will update shortly — check your profile if this stays blank.'}
            </span>
          </div>
          <p className="wallet-summary__hint">
            1 blog = 5 credits. Credits never expire. You can buy more anytime from Profile.
          </p>
        </div>
      )}
      <div className="billing-return__actions">
        <Link to="/" className="submit-button billing-return__link-btn">
          Get started
        </Link>
      </div>
    </div>
  );
}

export function BillingCancelPage() {
  return (
    <div className="profile-container billing-return" role="main">
      <h2>Checkout cancelled</h2>
      <p>No charge was made. You can buy credits anytime from your profile.</p>
      <div className="billing-return__actions">
        <Link to="/" className="submit-button billing-return__link-btn">
          Get started
        </Link>
      </div>
    </div>
  );
}
